// Admin gate.
//
// The league app is public-read: anyone with the link sees tee sheets,
// pairings, strokes and standings. Editing requires the shared admin
// password.
//
// SCOPE OF PROTECTION -- read this before relying on it:
// This is a UI gate, not server-side security. It stops casual edits from
// players poking around the site. It does NOT stop someone technical who
// reads the JavaScript bundle or calls Supabase directly with the anon
// key. For real enforcement, switch to Supabase Auth and change the RLS
// write policies to `TO authenticated` (see the note in sql/01-schema.sql).

import { ADMIN_SESSION_KEY } from '../utils/constants';

const CONFIGURED = process.env.REACT_APP_ADMIN_PASSWORD || '';

export function isAdminPasswordConfigured() {
  return CONFIGURED.length > 0;
}

export function checkPassword(input) {
  if (!CONFIGURED) return false;
  return String(input) === CONFIGURED;
}

export function loadAdminSession() {
  try {
    const raw = sessionStorage.getItem(ADMIN_SESSION_KEY);
    if (!raw) return false;
    const { until } = JSON.parse(raw);
    if (Date.now() > until) {
      sessionStorage.removeItem(ADMIN_SESSION_KEY);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

// Admin session lasts 8 hours -- long enough to run a full league day.
export function saveAdminSession() {
  try {
    sessionStorage.setItem(
      ADMIN_SESSION_KEY,
      JSON.stringify({ until: Date.now() + 8 * 60 * 60 * 1000 })
    );
  } catch { /* private browsing */ }
}

export function clearAdminSession() {
  try { sessionStorage.removeItem(ADMIN_SESSION_KEY); } catch { /* noop */ }
}
